(function($) {
    // Existing filter functionality
    $('.team-member-listing .filter-buttons .btn').on('click', function(e) {
        e.preventDefault();
        const $this = $(this);
        const subCategory = $this.data('subcategory');
        
        // Update active state
        $this.siblings().removeClass('is-active');
        $this.addClass('is-active');
        
        // Close dropdown
        $this.closest('.filter-buttons').removeClass('is-open');
        $this.closest('.location-filters').find('.filter-label').removeClass('is-open');
        
        // Filter items
        if(subCategory === 'all') {
            const $grid = $this.closest('.team-member-listing').find('.team-grid');
            $grid.find('.team-member').addClass('is-active');
        } else {
            const $grid = $this.closest('.team-member-listing').find('.team-grid');
            $grid.find('.team-member').removeClass('is-active');
            $grid.find('.team-member.subcategory-' + subCategory).addClass('is-active');
        }
    });
})(jQuery); 